export interface IDataSourceError {
    type: 'message' | 'validation';
}

